import { NavLink } from 'react-router-dom'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Icon, List } from '@/ui'
import { mtc } from '@/styles'
import { navListItemStyles } from './styles'

export interface RailNavListProps {
  categories?: Record<
    string,
    {
      end?: boolean
      icon?: IconProp
      label: string
      to?: string
      disabled?: boolean
    }
  > | null
  disabled?: boolean
  onCategoryClick?: (key: string) => void
}

export const RailNavList = ({
  categories,
  onCategoryClick,
}: RailNavListProps) => {
  if (!categories) {
    return null
  }

  return (
    <List className="px-2">
      {categories &&
        Object.entries(categories).map(([key, category]) => (
          <List.Item
            key={key}
            className={mtc(navListItemStyles())}
            onClick={() => onCategoryClick?.(key)}
          >
            <NavLink key={key} end={category.end} to={category.to ?? ''}>
              <div>
                {category.icon && <Icon icon={category.icon} size="1x" />}
              </div>
            </NavLink>
          </List.Item>
        ))}
    </List>
  )
}
